import apiEndpoints from '@/@enums/apiEndpoints';

export default {
  apiEndpoints,
};
